import { render } from "./CompatDropzone.vue?vue&type=template&id=34fc6be6&scoped=true"
import script from "./CompatDropzone.vue?vue&type=script&lang=js"
export * from "./CompatDropzone.vue?vue&type=script&lang=js"

import "./CompatDropzone.vue?vue&type=style&index=0&id=34fc6be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fc6be6"]])

export default __exports__